<template>
	<div>
		<transition name="modal">
			<div class="modal-mask">
				<div class="modal-wrapper" @click="$emit('closeModal')">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
							<div class="modal-container" @click.stop>
								<div class="modal-body">
                  <b-form @submit.prevent="console.log('Enter')">
                    <div class="row mt-3 mb-3">
                      <div class="col text-center">
                        <h2>{{ config.title }}</h2>
                      </div>
                    </div>

                    <b-form-row v-if="config.showDescription">
                      <b-form-group label="Deskripsi" class=" col-12">
                        <input type="text" class="form-control" v-model="desc">
                      </b-form-group>
                    </b-form-row>

                    <b-form-row>
                      <b-form-group label="Unggah Gambar" class="col-12">
                        {{fileError}}
                        <input :disabled="file.length >= config.imageCount" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize" multiple/>
                        <br>
                        <p v-if="config.imageCount > 1">Maksimal {{ config.imageCount }} Gambar</p>
                      </b-form-group>
                    </b-form-row>
                    <b-form-row v-if="file.length > 0 && url.length > 0">
                      <template class="w-100" >
                        <div v-for="(url, index) in url" :key="url" class="text-center row">
                          <b-form-group class="col-12 col-md text-center"  style="width:225px">
                            <img :src="url" class="img-fluid" style="height:15vh;"/>
                            <br>
                            <button type="button" @click="deleteImage(index)" class="btn btn-warning w-50 mt-2">Hapus</button>
                          </b-form-group>
                        </div>
                      </template>
                    </b-form-row>
                    <b-form-row >
                      <b-form-group class="col-6 text-center">
                        <button type="button" @click="$emit('closeModal')" class="btn btn-danger w-75">Batal</button>
                      </b-form-group>
                      <b-form-group class="col-6 text-center" v-if="file && url">
                        <button type="button" @click="uploadImage" class="btn btn-primary w-75" :disabled="url.length == 0">Unggah Gambar</button>
                      </b-form-group>
                    </b-form-row>
                  </b-form>
								</div>
							</div>
						</div>
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import watermark from 'watermarkjs'
import moment from 'moment'
import env from '@/env'
export default {
	data () {
		return {
			config : {
				title : 'Unggah Gambar',
				imageCount : 1,
				maxFileSize : 20,
				endpoint : env.urlStart + '/api/v1/workorder/image',

				passData : null,

				showDescription : false,
			},
					file: [],
					fileError: '',
			url: [],
			desc : '',
			loading : false
		}
	},
	props: [
		'title',//Title to be shown at the top; DEFAULT 'Unggah Gambar'
		'image_count',//Maximum number of images to be uploaded; DEFAULT '1'
		'max_file_size',//Maximum file size (in MB) ex. 4 == 4 MB; DEFAULT '8'
		'show_description',//Show description; DEFAULT false
		'pass_data',//Pass data upon uploading; DEFAULT null
		'endpoint',//Endpoint to upload image; DEFAULT '/api/v1/workorder/image'
	],
	mounted () {
		this.validateProps();
	},
	methods: {
		validateProps () {
			if (this.title != null) {//Check 'title'
				if (typeof this.title == 'string')
					this.config.title = this.title
				else
					this.errorPrint('title must be a string');
			}

			if (this.image_count != null) {//Check 'image_count'
				if (typeof this.image_count == 'number')
					this.config.imageCount = this.image_count
				else
					this.errorPrint('image_count must be an integer');
			}

			if (this.max_file_size != null) {//Check 'max_file_size'
				if (typeof this.max_file_size == 'number')
					this.config.maxFileSize = this.max_file_size
				else
					this.errorPrint('max_file_size must be an integer');
			}

			if (this.endpoint != null) {//Check 'endpoint'
				if (typeof this.endpoint == 'string')
					this.config.endpoint = this.endpoint
				else
					this.errorPrint('endpoint must be a string');
			}

			if (this.show_description != null) {//Check 'show_description'
				if (typeof this.show_description == 'boolean')
					this.config.showDescription = this.show_description
				else
					this.errorPrint('show_description must be a boolean');
			}

			if (this.pass_data != null) {//Check 'pass_data'
				this.config.passData = this.pass_data
			}
		},
		// Change ValidateSize Function To Allow Multiple Image Selected - Marvin T
		validateSize : function(data){
				
			var file = data.target.files;

			if (file.length > 3) {
				this.fileError = "Maximum Gambar Diunduh 3 Gambar"
				return false
			}

			for(var i = 0 ; i < file.length ; i ++) {
				var size  = file[i].size / 1024 / 1024;

				if(size > this.config.maxFileSize)
				{
					this.fileError = `Limit Size Gambar ${this.config.maxFileSize} MB`;
					return false;
				}

				

				this.fileError = "";
				let blobURL = URL.createObjectURL(file[i])
				let vm = this;

				if(size > 1) {
					let img = new Image();
					img.src = blobURL;
					img.onload = function (ev) {
						let canvas = document.createElement('canvas');
						canvas.width = img.width;
						canvas.height = img.height;
						console.log

						let ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0, img.width, img.height);

						let base64 = canvas.toDataURL('image/jpeg' , 0.6)


						let modifiedFile = vm.dataURLtoFile(base64 , 'image.jpg')
						vm.file.push(modifiedFile)
						vm.url.push(URL.createObjectURL(modifiedFile))

					};
				}
				else {
					this.file.push(file[i]) ;
					this.url.push(blobURL);
				}
			}

			return true;
				
		},
		async uploadImage () {
			console.log(this.loading)
			if(this.loading) {
				this.$store.dispatch('triggerAlert' , [false , 'Gambar Sedang diunggah. mohon ditunggu..'])
				return;
			}
			let image = await this.uploadAllImage()

			this.$emit('onResponse', this.config.showDescription ? {image : this.config.imageCount==1 ? image[0] : image, desc : this.desc} : this.config.imageCount==1 ? image[0] : image, this.config.passData);
		},
		async uploadS3Image (blob , type) {
			let url = env.awsImageUploader

			let response = await this.$http.get(url + '?type=' + type)

			let data = response.data


			const result = await fetch(data.uploadURL, {
              method: 'PUT',
              body: blob
            })
			console.log(result)

			return data.Key
		},
		async uploadAllImage() {
			let image = []

			this.loading = true
			let length = this.file.length
			let counter = 0

			for(var i = 0 ; i < this.file.length ;  i++) {
				let vm = this
				let date = new moment().format('MMM DD, Y HH:mm:ss')
				let type = this.file[i].type.split('/')[1].toUpperCase()

				// await watermark([this.file[i]])
				// .blob(watermark.text.lowerRight(date, '50px Arial', '#fff', 1))
				// .then(async function (blob) {

				// Temporary Remove Watermark
				await fetch(URL.createObjectURL(this.file[i]))
				.then(res => res.blob())
				.then(async (blob) => {
					// let filename = await vm.uploadS3Image(blob , type)
					// image.push(filename)


					// if(counter == length) {
					// 	this.loading = false
					// }
					// else {
					// 	counter++
					// }
					let file = new File([blob], 'test.png');


					let formData = new FormData()

					formData.append('image', file)
					
					await vm.$http.post(vm.config.endpoint, formData, {headers : {"Content-Type":'multipart/form-data'}})
					.then((resp) => {
						image.push(resp.data.data.filename)
						if(counter == length) {
						this.loading = false
						}
						else {
						counter++
						}
					})
					.catch((err) => {
						this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Uploading Image File.'])
						console.log(err)
					})
				})


				
					// 
				// });
				
			}
			
			return image
		},
		deleteImage (index) {
			this.url.splice(index, 1)
			this.file.splice(index , 1)
		}
	}
}
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
    margin:0
  }

  .modal-body .moduleLine{
    margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
    text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
    background-color: #E0E0E0;
    transition: background-color 0.7s ease;
    color: #212121;
    transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
    border:1px solid #BDBDBD;
    border-radius: 20px;
    padding: 20px 0;
    color:black;
    margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
    font-size:5vh;
  }

  h3.modalHeadline{
    margin:0 0 20px 0
  }
  /* MODAL ENDS */

  .modalContent tr th{
    text-align:right;
  }

  .modalContent tr .middleDivider{
    width: 50px;
    text-align: center;
  }
</style>